/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import NavigationItemRecord from '../records/NavigationItemRecord';
import globals from '../globals/globals';
export default (function () {
  if (!globals().accountsNavigationUrl) {
    throw new Error('mwfGlobals.accountsNavigationUrl is not defined');
  }

  var displayType = globals().accountsNavigationDisplayType || 'saml';
  var samlNavigation = displayType === 'saml';
  return new NavigationItemRecord({
    displayType: displayType,
    samlNavigation: samlNavigation,
    navigationUrl: globals().accountsNavigationUrl
  });
});